import { jwtDecode } from "jwt-decode";
import { getAccessToken } from "./authStorage";

export const decodeTokenService = {
  getToken() {
    return getAccessToken();
  },

  getEmailFromToken() {
    const token = this.getToken();
    if (!token) return null;
    // Use explicit type assertion to help TypeScript understand `jwtDecode`
    const decoded = jwtDecode<{ email?: string }>(token);
    return decoded.email || null;
  },

  getNameFromToken() {
    const token = this.getToken();
    if (!token) return null;

    // Use explicit type assertion to help TypeScript understand `jwtDecode`
    const decoded = jwtDecode<{ name?: string }>(token);
    return decoded.name || null;
  },

  getUserIdFromToken() {
    const token = this.getToken();
    if (!token) return null;

    // Use explicit type assertion to help TypeScript understand `jwtDecode`
    const decoded = jwtDecode<{ user_id?: string }>(token);
    return decoded.user_id || null;
  },
};
